import React from "react"
import { RootRouter } from "./router/Root.router"

export const App: React.FC = () => {
	return <RootRouter />
}
